(() => {
  /* sticky header: pin Shopify's section wrapper, keep --hdr equal to the real header height */
  const sh = document.getElementById('siteHeader');
  if (sh) {
    sh.parentElement.classList.add('hdr-wrap');
    const setH = () => document.documentElement.style.setProperty('--hdr', sh.offsetHeight + 'px');
    if ('ResizeObserver' in window) new ResizeObserver(setH).observe(sh);
    addEventListener('scroll', setH, { passive: true }); setH();
  }
  /* gift note -> cart note */
  let noteTimer, notePending = null;
  const saveNote = v => fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: v }) });
  document.addEventListener('input', e => {
    if (e.target.id !== 'cartNote') return;
    clearTimeout(noteTimer); const v = e.target.value;
    noteTimer = setTimeout(() => { notePending = saveNote(v); }, 400);
  });
  document.addEventListener('submit', async e => {
    const n = document.getElementById('cartNote'); if (!n || !e.target.closest('#cartFoot')) return;
    e.preventDefault(); clearTimeout(noteTimer);
    try { if (notePending) await notePending; await saveNote(n.value); } catch (_) {}
    const f = e.target; const h = document.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = '1'; f.appendChild(h); f.submit();
  });

  /* product page holiday notes */
  let H = {}; try { H = JSON.parse(document.getElementById('pbbHoliday').textContent) || {}; } catch (_) {}
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const sec = document.querySelector('[data-product-section]');
  if (sec) {
    const mto = sec.dataset.mto === 'true', kind = sec.dataset.kind;
    const band = sec.querySelector('.mto-band');
    if (mto && H.mto && band) {
      const p = document.createElement('p'); p.className = 'hol-note';
      p.innerHTML = esc(H.mto) + (H.link ? ` <a class="link" href="${esc(H.link)}">Shop Bond Boots</a>` : '');
      band.after(p);
    }
    const ul = sec.querySelector('.assure');
    if (!mto && kind !== 'limited' && H.cutoff && ul) {
      const li = document.createElement('li');
      li.innerHTML = `<span><b>Holiday delivery.</b> ${esc(H.cutoff)}</span>`;
      ul.insertBefore(li, ul.children[1] || null);
    }
  }

  /* 360 spin: fold the numbered spin frames into one draggable view */
  (() => {
    const sec = document.querySelector('[data-product-section]'); if (!sec) return;
    const thumbs = sec.querySelector('.thumbs'), box = sec.querySelector('.mainimg'), main = document.getElementById('mainImg');
    if (!thumbs || !box || !main) return;
    const btns = [...thumbs.querySelectorAll('button[data-media-src]')];
    const fname = u => decodeURIComponent(u.split('?')[0].split('/').pop()).toLowerCase();
    const groups = {};
    btns.forEach(b => {
      const n = fname(b.dataset.mediaSrc);
      if (n.startsWith('paul-bond-boots-')) return;
      const base = n.replace(/\.[a-z0-9]+$/, '').replace(/_[0-9a-f]{8}(-[0-9a-f]{4}){3}-[0-9a-f]{12}$/, '');
      if (!/\d+$/.test(base)) return;
      const k = base.replace(/[^a-z]/g, '');
      (groups[k] = groups[k] || []).push(b);
    });
    const set = Object.values(groups).sort((a, b) => b.length - a.length)[0] || [];
    if (set.length < 12) return;
    const urls = set.map(b => b.dataset.mediaSrc.replace(/([?&]width=)\d+/, '$11000'));
    set.forEach(b => { b.hidden = true; });

    const tb = document.createElement('button');
    tb.type = 'button'; tb.className = 'spin-thumb'; tb.setAttribute('aria-label', 'View the boot in 360°');
    tb.innerHTML = `<img src="${set[0].querySelector('img') ? set[0].querySelector('img').src : urls[0]}" alt=""><span>360°</span>`;
    const first = thumbs.querySelector('button:not([hidden])');
    first ? first.after(tb) : thumbs.prepend(tb);
    thumbs.hidden = false;

    const view = document.createElement('div');
    view.className = 'spin'; view.hidden = true; view.tabIndex = 0;
    view.setAttribute('role', 'img'); view.setAttribute('aria-label', '360° view of the boot. Drag or use the arrow keys to turn it.');
    view.innerHTML = '<img alt="" draggable="false"><p class="spin-hint">Drag to turn</p><div class="spin-bar"><i></i></div>';
    box.appendChild(view);
    const chip = document.createElement('button');
    chip.type = 'button'; chip.className = 'spin-chip'; chip.innerHTML = '<b>360°</b> Turn the boot';
    box.appendChild(chip);

    const img = view.querySelector('img'), bar = view.querySelector('.spin-bar i');
    const n = urls.length; let f = 0, loaded = false;
    const frames = [];
    const show = i => { f = ((i % n) + n) % n; img.src = urls[f]; bar.style.width = ((f + 1) / n * 100) + '%'; };
    const preload = () => {
      if (loaded) return Promise.resolve(); loaded = true;
      let done = 0;
      return new Promise(res => urls.forEach((u, i) => { const im = new Image(); im.onload = im.onerror = () => { if (++done === n) res(); }; im.src = u; frames[i] = im; }));
    };
    let on = false;
    const open = async () => {
      if (on) return; on = true;
      main.style.visibility = 'hidden'; view.hidden = false; chip.hidden = true; box.classList.add('spinning');
      [...thumbs.querySelectorAll('button')].forEach(x => x.classList.toggle('on', x === tb));
      show(0); view.classList.add('loading');
      await preload(); view.classList.remove('loading');
      let k = 0; const t = setInterval(() => { show(k++); if (k > n) clearInterval(t); }, 45);
    };
    const close = () => { if (!on) return; on = false; main.style.visibility = ''; view.hidden = true; chip.hidden = false; box.classList.remove('spinning'); };
    tb.addEventListener('click', open); chip.addEventListener('click', open);
    thumbs.addEventListener('click', e => { const b = e.target.closest('button'); if (b && b !== tb) close(); });

    let sx = null, sf = 0;
    view.addEventListener('pointerdown', e => { sx = e.clientX; sf = f; view.setPointerCapture(e.pointerId); view.classList.add('drag'); view.classList.add('used'); });
    view.addEventListener('pointermove', e => { if (sx === null) return; const step = view.clientWidth / n; show(sf - Math.round((e.clientX - sx) / step)); });
    const up = () => { sx = null; view.classList.remove('drag'); };
    view.addEventListener('pointerup', up); view.addEventListener('pointercancel', up);
    view.addEventListener('keydown', e => { if (e.key === 'ArrowLeft') { show(f + 1); e.preventDefault(); } if (e.key === 'ArrowRight') { show(f - 1); e.preventDefault(); } });
  })();
})();
